import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgFreePremiumCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 76,
	height: 76,
	viewBox: "0 0 76 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 6328",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group 6336",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M10.7534 9.15173H65.1457L75.7955 75.2373H20.4664L10.7534 9.15173Z",
						fill: "#D6D6D6"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Vector_2",
							d: "M65.0199 9.19403H10.7557L8.64313 22.2905H62.9116L65.0199 9.19403Z",
							fill: "#E9BBFF"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Vector_3",
							d: "M8.64109 22.2482L0.103882 75.2373H54.3724L62.9096 22.2482H8.64109Z",
							fill: "white"
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M19.2474 7.47742L18.4969 12.2492",
						stroke: "black",
						strokeWidth: 1.78919,
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_5",
						d: "M53.7261 7.47742L52.9756 12.2492",
						stroke: "black",
						strokeWidth: 1.78919,
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_6",
						d: "M42.2347 7.47742L41.4843 12.2492",
						stroke: "black",
						strokeWidth: 1.78919,
						strokeLinecap: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_7",
						d: "M30.7435 7.47742L29.993 12.2492",
						stroke: "black",
						strokeWidth: 1.78919,
						strokeLinecap: "round"
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "3Oì¼ ë¬´ë£ì²´í",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Union",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M41.4759 34.7649C41.6107 33.2239 40.3841 32.1303 38.6252 32.1303C36.8662 32.1303 35.4482 33.2239 35.3134 34.7649C35.1797 36.2934 36.4063 37.387 38.1653 37.387C39.9242 37.387 41.3422 36.2934 41.4759 34.7649ZM36.9102 34.7649C36.9819 33.9447 37.6595 33.4725 38.5077 33.4725C39.356 33.4725 39.9384 33.9447 39.8667 34.7649C39.7949 35.5851 39.1299 36.0573 38.2816 36.0573C37.4333 36.0573 36.8384 35.5851 36.9102 34.7649ZM45.0041 31.7948H43.3325L42.8291 37.5486H44.5007L45.0041 31.7948ZM44.4594 38.0208H36.7501L36.6381 39.3008H42.7007L42.6409 39.9843H36.6032L36.4358 41.8981L36.3771 42.5692L36.3238 43.1781H44.2951L44.4071 41.8981H38.0575L38.1206 41.1773H44.1832L44.4594 38.0208ZM49.5758 47.9879H51.2349L50.6272 54.9347H48.968L49.1637 52.6978H47.7167L47.8341 51.3556H49.2812L49.5758 47.9879ZM42.8879 55.4193H50.5848L50.239 59.3712H42.5422L42.8879 55.4193ZM48.8489 56.7242H44.408L44.2905 58.0663H48.7315L48.8489 56.7242ZM41.5176 48.982H44.0624L44.1581 47.8884H45.8172L45.7215 48.982H48.2663L48.1522 50.2869H41.4034L41.5176 48.982ZM44.7514 50.6597C46.3606 50.6597 47.4333 51.5172 47.3267 52.735C47.2191 53.9653 45.9986 54.798 44.3894 54.798C42.7801 54.798 41.6928 53.9653 41.8005 52.735C41.907 51.5172 43.1422 50.6597 44.7514 50.6597ZM44.6438 51.89C43.9327 51.89 43.4337 52.1758 43.3847 52.735C43.3358 53.2943 43.7838 53.5925 44.4948 53.5925C45.1934 53.5925 45.6935 53.2943 45.7424 52.735C45.7914 52.1758 45.3423 51.89 44.6438 51.89ZM34.7871 52.3502H36.097L36.4623 48.1746H38.0091L37.0643 58.9738H35.5175L35.9806 53.6799H34.6708L34.7871 52.3502ZM30.4055 51.2441H32.2019L32.1812 51.4803C32.0268 53.2449 31.2753 55.1338 29.5449 56.0907L30.3718 57.3335C31.4608 56.7401 32.2247 55.7232 32.7223 54.5207C33.0292 55.6216 33.6251 56.5313 34.5996 57.0601L35.6043 55.8422C34.0463 54.9723 33.6008 53.2201 33.753 51.4803L33.7737 51.2441H35.5575L35.6739 49.9144H33.89L34.0248 48.3735H32.453L32.3182 49.9144H30.5219L30.4055 51.2441ZM38.8113 47.9882H40.3831L39.3764 59.4958H37.8046L38.8113 47.9882ZM21.3963 55.1331H19.9492L20.0047 54.4993L20.0656 53.8034L20.2885 51.2558H26.7253L26.8319 50.0379H20.3701L20.4842 48.7331H28.5927L28.2589 52.5482H21.822L21.7122 53.8034H28.4111L28.2947 55.1331H26.673L26.5197 56.8853H29.0521L28.9347 58.2274H18.481L18.5984 56.8853H21.243L21.3963 55.1331ZM22.8647 56.8853H24.898L25.0513 55.1331H23.018L22.8647 56.8853ZM7.69978 54.4257H18.166L18.0507 55.743H13.5973L13.2689 59.496H11.6223L11.9506 55.743H7.58453L7.69978 54.4257ZM9.42408 48.5476H17.4328L17.0261 53.1954H9.01745L9.42408 48.5476ZM15.6844 49.8525H10.9441L10.7658 51.8905H15.5061L15.6844 49.8525Z",
					fill: "black"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group 6310",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group 6323",
					children: [/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse 374",
						cx: 9.11629,
						cy: 9.16887,
						rx: 9.11629,
						ry: 9.16887,
						transform: "matrix(1 0 -0.121869 0.992546 57.5624 0.762451)",
						fill: "#FF3F3F"
					}), /* @__PURE__ */ _jsx("path", {
						id: 1,
						d: "M67.5363 5.75711L65.3886 13.9174L63.8877 13.9179L65.6035 7.39181L65.5606 7.39182L64.0468 8.27877L63.6919 7.30701L66.2927 5.75753L67.5363 5.75711Z",
						fill: "white"
					})]
				})
			})
		]
	})
});
export default SvgFreePremiumCalendar;
